import script from "./NavbarDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarDesktop.vue?vue&type=script&setup=true&lang=js"

import "./NavbarDesktop.vue?vue&type=style&index=0&id=53f0938e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f0938e"]])

export default __exports__